import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import { SupplierOverviewItem } from "./SupplierOverviewItem";
import { DefaultLoadingTimeFilterCell } from "./DefaultLoadingTimeFilterCell";
import { DefaultLoadingTimeGridCell } from "./DefaultLoadingTimeGridCell";
import { customDecimalFilterCell } from "../../Layout/Filter/CustomDecimalFilterCell";

function SupplierOverviewItemGridColumns() {
  return [
    columnForField<SupplierOverviewItem>("Gsdb", {
      locked: true,
      title: "GSDB",
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("Name", { width: "300px" }),
    columnForField<SupplierOverviewItem>("Street", { width: "300px" }),
    columnForField<SupplierOverviewItem>("Zipcode", {
      title: "Postcode",
      width: "175px",
    }),
    columnForField<SupplierOverviewItem>("ZipArea", {
      title: "Postcode Area",
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("City", { width: "200px" }),
    columnForField<SupplierOverviewItem>("CountryName", {
      title: "Country",
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("CountryCode", {
      title: "CMMS Country Code",
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("AreaCode", {
      title: "CMMS Area Code",
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("CollectionRegion", {
      title: "Region",
      width: "250px",
    }),
    columnForField<SupplierOverviewItem>("Latitude", {
      width: "200px",
    }),
    columnForField<SupplierOverviewItem>("Longitude", {
      width: "200px",
    }),
    columnForField<SupplierOverviewItem>("MgLatitude", {
      title: "M&G Latitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("MgLongitude", {
      title: "M&G Longitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<SupplierOverviewItem>("DefaultLoadingTime", {
      title: "Default Stop Time",
      cell: DefaultLoadingTimeGridCell,
      filterCell: DefaultLoadingTimeFilterCell,
      width: defaultColumnWidth,
    }),
  ];
}

export default SupplierOverviewItemGridColumns;
